import React from 'react';
import Countdown from 'react-countdown';

import Navbar from '../components/TopNav';
import Footer from '../components/Footer';

const Game = () => {
  const tDate = new Date('12 16 2021');
  const utcDate = tDate.toUTCString();
  const renderer = ({ days,hours, minutes, seconds, completed }) => {
      const day = days.toString().length === 1 ? 0 : ''
      const hour = hours.toString().length === 1 ? 0 : ''
      const min = minutes.toString().length === 1 ? 0 : ''
      const sec = seconds.toString().length === 1 ? 0 : ''
      return (
        <p className="time-p hide">
         <span className="time">{day}{days}</span> : <span className="time">{hour}{hours}</span> : <span className="time">{min}{minutes}</span> : <span className="time">{sec}{seconds}</span>
        </p>
      );
  };
  return (
    <div className="row no-gutters game">
      <Navbar />
      <div className="col-12 main">
        <h5>ALPHA RELEASE DATE</h5>
        <h1>COMING SOON</h1>
        <p>Excitement is about to start as Monsters Clan game alpha version
           will be released soon.</p>
        <Countdown renderer={renderer}
          date={utcDate} />
      </div>
      <Footer />
     </div>
  )
}

export default Game;